import { gql } from "@apollo/client";

const STUDENT_LOGIN = gql`
  mutation StudentLogin($email: String!, $password: String!) {
    studentLogin(email: $email, password: $password) {
      authenticatable {
        givenName
        familyName
        locale
        activeSubscription {
          status
        }
        currentLanguage {
          id
          englishName
          realName
        }
      }
      credentials {
        uid
        accessToken
        client
      }
    }
  }
`;

export default STUDENT_LOGIN;
